import * as angular from 'angular';
import * as _ from 'lodash';

import { AlarmRowViewModel, ComponentDefinition, Dictionary, IFrequency } from '../../../../models';
import { AlarmModes, severityLevels } from '../../../../common';
import { ICurrentApplicationService, toDuration } from '../../../../services';

class AlarmsDumbTableController implements angular.IComponentController {
    alarms: AlarmRowViewModel[];
    changedItems: AlarmRowViewModel[];
    headings?: Dictionary<boolean>;
    levels = severityLevels;
    modes = AlarmModes;
    tableFormController: angular.IFormController;

    private _baseFreq: { interval: number; intervalTimeUnit: any };

    static $inject = ['currentApplicationService'];

    constructor(currentApplicationService: ICurrentApplicationService) {
        const conf = currentApplicationService.getApplicationConfiguration();
        this._baseFreq = { interval: conf.interval, intervalTimeUnit: conf.intervalTimeUnit };
    }

    $onInit() {
        this.changedItems = [];
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        this.changedItems = [];
    }

    onChange(viewModel: AlarmRowViewModel) {
        if (viewModel && this.changedItems.indexOf(viewModel) < 0) {
            if (viewModel.alarm.isManual) {
                viewModel.alarm.low = undefined;
                viewModel.alarm.high = undefined;
            }
            this.changedItems.push(viewModel);
        }
    }

    validateDelay(row: AlarmRowViewModel, frequency: IFrequency) {
        let isValid = false;

        if (row && frequency.interval >= 0) {
            // must be multiple of group freq
            const freqAsMilli = toDuration(frequency).asMilliseconds();
            isValid = _.every(row.identifier.groupList, (group) => {
                const baseDuration = toDuration(group.frequency?.interval !== 0 ? group.frequency : this._baseFreq);
                return freqAsMilli % baseDuration.asMilliseconds() === 0;
            });
        }

        const intervalUnitField: angular.INgModelController = this.tableFormController[`${row.alarm.guid}intervalUnit`];
        const intervalField: angular.INgModelController = this.tableFormController[`${row.alarm.guid}Interval`];
        if (intervalUnitField && intervalField) {
            intervalField.$setValidity('interval', isValid);
            intervalUnitField.$setValidity('interval', isValid);
        }

        this.onChange(row);
    }
}

export const wtAlarmsDumbTable: ComponentDefinition = {
    componentId: 'wtAlarmsDumbTable',
    controller: AlarmsDumbTableController,
    template: require('./alarmsDumbTable.component.html'),
    controllerAs: 'vm',
    bindings: {
        alarms: '<',
        changedItems: '=?',
        headings: '<?',
        isEditMode: '<?',
        tableFormController: '=?'
    }
};
